import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';

import { ChatMessage, ChatRole, MessageContent } from '../../../../models/agent.models';
import { ChatUserSettings } from '@dataclouder/ngx-core';

import { MessageOrchestratorComponent } from '../message-orchestrator/message-orchestrator.component';

const EVALUATION_EMOJIS: { [key: number]: string } = {
  0: '😐',
  1: '👍',
  2: '⭐',
  3: '💎',
};

@Component({
  selector: 'dc-chat-message',
  standalone: true,
  imports: [CommonModule, MessageOrchestratorComponent],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageComponent {
  // Inputs
  chatMessage = input.required<ChatMessage>();
  chatUserSettings = input<ChatUserSettings | null>(null);
  // Signal States
  public audioMessage = signal<MessageContent | null>(null);

  // Computed properties for easier access to signal values
  hasMultiMessages = computed(() => !!this.chatMessage()?.multiMessages);
  multiMessages = computed(() => this.chatMessage()?.multiMessages || []);
  messageTranslation = computed(() => this.chatMessage()?.translation);
  isUserMessage = computed(() => this.chatMessage()?.role === ChatRole.User);

  evaluationEmoji = computed(() => {
    const score = this.chatMessage()?.evaluation?.['score'];
    if (score === null || score === undefined) {
      return '';
    }
    return EVALUATION_EMOJIS[+score] || '';
  });

  // Field initializer for the effect - runs during component creation
  private messageEffect = effect(() => {
    const message = this.chatMessage();
    if (!message) return;

    if (message.role === ChatRole.AssistantHelper) {
      return;
    }

    if (message.role === ChatRole.User) {
      this.audioMessage.set({ ...message });
    } else if (message.role === ChatRole.Assistant) {
      if (this.multiMessages().length > 0) {
      } else {
        this.audioMessage.set({ ...message });
      }
    }
  });

  public showEvaluation() {
    console.log('showEvaluation', this.chatMessage().evaluation);

    alert(this.chatMessage().evaluation?.['feedback'] || 'No feedback available');
  }

  public printData() {
    console.log(this.chatMessage());
  }
}
